import closeSymbol from '../../_metronic/images/closeSymbol.svg'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import SVG from 'react-inlinesvg'
const modalsRoot = document.getElementById('root-modals') || document.body

type sharedModalProps = {
  handleClose: () => void
  headerContent?: any
  headerName: string
  show: boolean
  children: string | JSX.Element | JSX.Element[]
  handleSubmit: () => void
  className: string
  disableSubmit?: boolean
  submitText?: string
}

const SharedModal = ({
  handleClose,
  headerContent,
  headerName,
  show,
  children,
  handleSubmit,
  className,
  disableSubmit,
  submitText,
}: sharedModalProps) => {

  return createPortal(
    <Modal
      id='kt-modal_create_app'
      tabIndex={-1}

      aria-hidden='true'
      dialogClassName={className}
      show={show}
      onHide={() => handleClose()}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>{headerName}</h2>
        <div className='d-flex'>
          {headerContent}
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => handleClose()}
          >
            <SVG src={closeSymbol}></SVG>
          </div>
        </div>
      </div>
      <div className='hover-scroll-overlay-y mh-550px product-form'>{children}</div>
      <div
        className='modal-footer sticky-bottom bg-white'
        style={{ borderRadius: '0 0 20px 20px', zIndex: '2' }}
      >
        <button type='button' className='btn btn-light' onClick={() => handleClose()}>
          Discard
        </button>
        <button
          onClick={() => handleSubmit()}
          disabled={disableSubmit}
          className='btn btn-primary'
          data-kt-stepper-action='submit'
        >
          {Boolean(submitText) ? submitText : 'Submit'}
        </button>
      </div>
    </Modal>,
    modalsRoot
  )
}
export default SharedModal
